 <template>
    <el-popover trigger="click" placement="bottom-start" :disabled="!update">
        <el-link slot="reference" type="primary" :underline="update">
            {{ value }}
            <i v-if="update" class="el-icon-edit el-icon--right"></i>
        </el-link>
        <el-date-picker size="mini" v-model="date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="OnChange"></el-date-picker>
    </el-popover>
</template>
<script>
export default {
    props: {
        value: {
            type: String,
            default: null
        },
        contract_id: {
            type: Number,
            default: null
        },
        update: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            date: null,
        }
    },
    watch: {
        value: {
            handler(val) {
                this.date = val
            },
            immediate: true
        }
    },
    methods: {
        OnChange(val) {
            if (this.contract_id && this.update) {
                this.$http.post('/9api/contract/update-sign-date', {id: this.contract_id, sign_date: val}).then(rps => {
                    this.$emit('input', val)
                })
            }
        },
    }
}
</script>